var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCameraIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 15.8333L23.1575 18.6666H18.6667C17.1084 18.6666 15.8334 19.9416 15.8334 21.4999V38.4999C15.8334 40.0583 17.1084 41.3333 18.6667 41.3333H41.3334C42.8917 41.3333 44.1667 40.0583 44.1667 38.4999V21.4999C44.1667 19.9416 42.8917 18.6666 41.3334 18.6666H36.8425L34.25 15.8333H25.75ZM30 37.0833C26.09 37.0833 22.9167 33.9099 22.9167 29.9999C22.9167 26.0899 26.09 22.9166 30 22.9166C33.91 22.9166 37.0834 26.0899 37.0834 29.9999C37.0834 33.9099 33.91 37.0833 30 37.0833Z",
    fill: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 34.533C32.5037 34.533 34.5334 32.5033 34.5334 29.9996C34.5334 27.496 32.5037 25.4663 30 25.4663C27.4963 25.4663 25.4667 27.496 25.4667 29.9996C25.4667 32.5033 27.4963 34.533 30 34.533Z",
    fill: "#CDCDCD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/cameraIcon.af1d32cc0872abe30dd4aa8ec3b4ecc2.svg";
export { ForwardRef as ReactComponent };